import { API_AUTH, setTokenGlobal } from "./common";
import { Cookies } from "react-cookie";
import { getDomain } from "utils/utils";

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get("userTokenDaiLy");
if (typeof token != "undefined" && token.length > 6) {
  token = token.substring(6);
  setTokenGlobal(token, urlNew);
}

const DatHangDaiLyApi = {
  list: ({
    username,
    tensanpham,
    nhomsanphamId,
    hashtag,
    branchId,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `congthucsanpham/getDanhSachSanPhamDaiLy?username=${username}&tensanpham=${encodeURIComponent(
        tensanpham,
      )}&nhomsanphamId=${nhomsanphamId}&hashtag=${hashtag}&branchId=${branchId}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {},
    ),
  listNhomSanPham: (iBranch) => {
    return API_AUTH.get(
      `congthucsanpham/getDanhMucGroupCategories?iBranch=${iBranch}`,
      {},
    );
  },
  listHashtag: () => {
    return API_AUTH.get(`congthucsanpham/combostatushashtag`, {});
  },
  addOrUpdateDatHang: (params) =>
    API_AUTH.post(
      "dathang/addOrUpdateDatHang?sUserName=" + params.sUserName,
      params,
    ),
  listGiaoDich: (customerId, tungay, denngay, pageIndex, pageSize) => {
    return API_AUTH.get(
      `khachhang/chitietthongtincongnokhachhang?customerId=${customerId}&tungay=${tungay}&denngay=${denngay}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {},
    );
  },
  addGioHang: (params) => API_AUTH.post("dathang/LuuGioHang", params),
  listThongTinGioHang: (userName) => {
    return API_AUTH.get(`dathang/ThongTinGioHang?userName=${userName}`, {});
  },
  yeuCauBaoGia: (params) =>
    API_AUTH.post(
      "baogiadaily/TaoBaoGiaDaiLy?sUserName=" + params.sUserName,
      params,
    ),
  danhSachBaoGiaDaiLy: ({
    sUserName,
    tuNgay,
    denNgay,
    iPageIndex,
    iPageSize,
    sMaBaoGia,
  }) =>
    API_AUTH.get(
      `baogiadaily/DanhSachBaoGiaDaiLy?sUserName=${sUserName}&tuNgay=${tuNgay}&denNgay=${denNgay}&iPageIndex=${iPageIndex}&iPageSize=${iPageSize}&sMaBaoGia=${sMaBaoGia}`,
    ),
  chiTietBaoGiaDaiLy: (Id, sUserName) =>
    API_AUTH.get(
      `baogiadaily/GetBaoGiaDaiLyByID?sUserName=${sUserName}&Id=${Id}`,
    ),
  ganOrderIdVaoBaoGia: (sUserName, baoGiaId, orderDatHangId) =>
    API_AUTH.post(
      `baogiadaily/GanOrderIdVaoBaoGia?sUserName=${sUserName}&baoGiaId=${baoGiaId}&orderDatHangId=${orderDatHangId}`,
    ),
  getThongBao: (sUserName) =>
    API_AUTH.get(`notification/GetThongBaoDaiLy?sUserName=${sUserName}`),
  danhDauDaDoc: (sUserName, id) =>
    API_AUTH.post(`notification/DanhDauDaDoc?sUserName=${sUserName}&id=${id}`),
  danhDauTatCaDaDoc: (sUserName) =>
    API_AUTH.post(`notification/DanhDauTatCaDaDoc?sUserName=${sUserName}`),
};

export default DatHangDaiLyApi;
